const normalizeUrl = (value: string) => value.replace(/\/+$/, "");

// Fallback is the LOCAL dev URL — production values are injected via .env.production / DefinePlugin
const fallbackSupplierApiUrl = "https://erpapi.kaanpos.com";
const fallbackAdminApiUrl = "https://erpapi.kaanpos.com";

const supplierApiUrl = process.env.SUPPLIER_API_URL || fallbackSupplierApiUrl;
const adminApiUrl = process.env.ADMIN_API_URL || fallbackAdminApiUrl;

export const runtimeConfig = {
  supplierApiUrl: normalizeUrl(supplierApiUrl),
  adminApiUrl: normalizeUrl(adminApiUrl),
} as const;
